<script setup lang="ts">
import { computed } from 'vue';
import { cn } from '@/lib/cn';

const props = defineProps<{ size?: 'sm' | 'md' | 'lg'; class?: string }>();

const heightClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'h-5';
    case 'lg':
      return 'h-7';
    default:
      return 'h-6';
  }
});
</script>

<template>
  <div
    :class="cn('inline-flex items-center text-text select-none', props.class)"
    aria-label="Aitelier"
  >
    <svg
      :class="cn('w-auto', heightClass)"
      viewBox="0 0 120 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M10.978 22.772H5.214L4.29 25.5H0.352L5.94 10.056H10.296L15.884 25.5H11.902L10.978 22.772ZM10.01 19.868L8.096 14.214L6.204 19.868H10.01ZM21.1267 10.056V25.5H17.3647V10.056H21.1267ZM34.743 10.056V13.07H30.651V25.5H26.889V13.07H22.797V10.056H34.743ZM40.173 13.07V16.194H45.211V19.098H40.173V22.486H45.871V25.5H36.411V10.056H45.871V13.07H40.173ZM51.8554 22.596H56.7834V25.5H48.0934V10.056H51.8554V22.596ZM62.1198 10.056V25.5H58.3578V10.056H62.1198ZM68.388 13.07V16.194H73.426V19.098H68.388V22.486H74.086V25.5H64.626V10.056H74.086V13.07H68.388ZM84.1844 25.5L80.9724 19.67H80.0704V25.5H76.3084V10.056H82.6224C83.8397 10.056 84.8737 10.2687 85.7244 10.694C86.5897 11.1193 87.235 11.706 87.6604 12.454C88.0857 13.1873 88.2984 14.0087 88.2984 14.918C88.2984 15.9447 88.005 16.8613 87.4184 17.668C86.8464 18.4747 85.9957 19.0467 84.8664 19.384L88.4304 25.5H84.1844ZM80.0704 17.008H82.4024C83.0917 17.008 83.605 16.8393 83.9424 16.502C84.2944 16.1647 84.4704 15.688 84.4704 15.072C84.4704 14.4853 84.2944 14.0233 83.9424 13.686C83.605 13.3487 83.0917 13.18 82.4024 13.18H80.0704V17.008Z" />
      <path d="M97 0L99.0541 4.94586L104 7L99.0541 9.05414L97 14L94.9459 9.05414L90 7L94.9459 4.94586L97 0Z" />
    </svg>
  </div>
</template>
